var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 11.375H28.25C27.2144 11.375 26.375 12.2144 26.375 13.25V27.3125C26.375 28.5331 27.1611 29.564 28.25 29.9523V31.0625C28.25 31.5807 28.6693 32 29.1875 32C29.7057 32 30.125 31.5807 30.125 31.0625V29.9523C31.2139 29.564 32 28.5331 32 27.3125V13.25C32 12.2144 31.1606 11.375 30.125 11.375ZM23.4375 0H0.9375C0.412438 0 0 0.412437 0 0.9375V31.0625C0 31.5874 0.412438 32 0.9375 32H17.8125L19.6875 27.3125L24.375 25.4375V0.9375C24.375 0.412437 23.9626 0 23.4375 0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 24.5H11.25V23.5625C11.25 23.1835 11.0211 22.8411 10.6714 22.6964C10.3235 22.5499 9.91702 22.6305 9.64964 22.8997L9.37502 23.1743V21.6875C9.37502 21.3085 9.14614 20.9661 8.79639 20.8214C8.44852 20.6759 8.04383 20.7564 7.77464 21.0247L4.02464 24.7747C3.65845 25.1409 3.65845 25.7342 4.02464 26.1004C4.39083 26.4666 4.98414 26.4666 5.35033 26.1004L7.50002 23.9507V25.4375C7.50002 25.8165 7.72889 26.1589 8.07864 26.3036C8.41952 26.4469 8.82789 26.3728 9.10039 26.1003L9.43364 25.7661C9.56727 26.1223 9.9097 26.375 10.3125 26.375H14.0625C14.5807 26.375 15 25.9557 15 25.4375C15 24.9193 14.5807 24.5 14.0625 24.5ZM17.8125 26.375V32C18.0563 32 18.3 31.9062 18.4687 31.7187L24.0937 26.0937C24.2813 25.925 24.375 25.6812 24.375 25.4375H18.75C18.2323 25.4375 17.8125 25.8573 17.8125 26.375ZM8.43752 7.625H15.9375C16.4557 7.625 16.875 7.20569 16.875 6.6875C16.875 6.16931 16.4557 5.75 15.9375 5.75H8.43752C7.91933 5.75 7.50002 6.16931 7.50002 6.6875C7.50002 7.20569 7.91933 7.625 8.43752 7.625ZM6.56252 11.375H17.8125C18.3307 11.375 18.75 10.9557 18.75 10.4375C18.75 9.91931 18.3307 9.5 17.8125 9.5H6.56252C6.04433 9.5 5.62502 9.91931 5.62502 10.4375C5.62502 10.9557 6.04433 11.375 6.56252 11.375ZM6.56252 15.125H17.8125C18.3307 15.125 18.75 14.7057 18.75 14.1875C18.75 13.6693 18.3307 13.25 17.8125 13.25H6.56252C6.04433 13.25 5.62502 13.6693 5.62502 14.1875C5.62502 14.7057 6.04433 15.125 6.56252 15.125ZM6.56252 18.875H17.8125C18.3307 18.875 18.75 18.4557 18.75 17.9375C18.75 17.4193 18.3307 17 17.8125 17H6.56252C6.04433 17 5.62502 17.4193 5.62502 17.9375C5.62502 18.4557 6.04433 18.875 6.56252 18.875ZM31.0625 5.75H27.3125C26.7948 5.75 26.375 6.16975 26.375 6.6875V13.25H32V6.6875C32 6.16975 31.5803 5.75 31.0625 5.75Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16,
    y1: 32,
    x2: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 17.875,
    y1: 32,
    x2: 17.875,
    y2: 5.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D61DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D8DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.0f64b0f5466ca3a7c3ac5e552d81745f.svg";
export { ForwardRef as ReactComponent };